import React from "react";

const TuitionModalStudentCard = ({ image, name, id, today, appearence }) => {
  return (
    <tr>
      <td>
        <div className="flex-row align-center justify-start g-05">
          <img
            src={image}
            alt=""
            style={{
              width: "2.5rem",
              height: "2.5rem",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
          <div className="flex-col align-start justify-start">
            <span className="t-14 poppins">{name}</span>
            <span className="t-11 color-grayColor poppins">ID: {id}</span>
          </div>
        </div>
      </td>
      <td className="t-13 poppins color-greenColor">{today}</td>
      <td className="t-13 poppins color-greenColor">{appearence}</td>
    </tr>
  );
};

export default TuitionModalStudentCard;
